import { bool } from "prop-types";
import { observer } from "mobx-react";
import {
  usePresetFieldNames,
  useEstimateStructure,
  useEstimateEditorSettings,
  EstimateCurrencyEditor,
  ValueCell,
} from "@tools";

export const UnitCostCell = observer(({
  extendPadding,
  company,
}) => {
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  const structure = useEstimateStructure();
  const { currency, companyCurrency } = structure.settings;
  
  return (
    <ValueCell
      size="large"
      isHeader
      style={{ cursor: allowEdition && "grab" }}
      extendPadding={extendPadding}
    >
      <span>
        { `${getFieldName("pt-hourlyCost")} (${company ? companyCurrency : currency})` }
      </span>
      {
        company && allowEdition &&
        <EstimateCurrencyEditor useCompanyCurrency={company} />
      }
    </ValueCell>
  )
})

UnitCostCell.propTypes = {
  extendPadding: bool,
  company: bool,
}